<template>
  <div
    class="LifeIndex"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="false"
  >
    <!-- <div :style="{ marginTop: unionFlag ? '20px' : '' }" class="advise-banner"> -->
    <div class="advise-banner">
      <LeftNavList
        :catList="catList"
        :onChange="
          (id,item,type) => {
            toListPage(id,item,type);
          }
        "
        v-if="catList.length"
      />
      <Carousel
        v-if="bannerImg.length > 0"
        :interval="3000"
        arrow="hover"
        height="455px"
      >
        <CarouselItem v-for="(item, index) in bannerImg" :key="index">
          <a
            :href="
              unionFlag
                ? item.bfdUrl
                  ? item.bfdUrl
                  : 'javascript:void(0)'
                : item.adUrl
                ? item.adUrl
                : 'javascript:void(0)'
            "
            target="_self"
            @click.prevent="clickCarousel(item)"
          >
            <img :src="item.adImg" alt :style="{ background: '#ccc' }" />
          </a>
        </CarouselItem>
      </Carousel>
      <!-- <div class="bfd-banner" v-if="bannerImg.length <= 0 && unionFlag">
        <img :src="require('@assets/images/life_banner.jpg')" />
      </div> -->
    </div>

    <div class="goods-wrap">
      <ul ref="goodsWrap">
        <!-- 循环匹配 都按indexCategoryDtos 这个顺序显示 -->
        <div v-for="cate in indexCategoryDtos" :key="cate.id">
          <li v-for="(item, index) in indexCategoryGoodsDtos" :key="index">
            <div v-if="cate.id === item.categoryId">
              <div class="header-title">
                <div class="title-left">
                  <span>{{ item.categoryName }}</span>
                  <span class="en">{{ cate.enName }}</span>
                </div>
                <div class="title-right" @click="toListPage(item.categoryId,item)">
                  <span>{{TLang('查看更多','my')}}</span>
                  <i class="icon iconfont">&#xe657;</i>
                </div>
              </div>
              <div class="goodsList">
                <div
                  v-for="(goods, i) in item.indexSpuGoodsDtoList"
                  :key="i"
                  class="item"
                >
                  <GoodsItem
                    :goods="goods"
                    :onClick="toDetailPage"
                    :onClickAdd="onClickAdd.bind(undefined, goods,item)"
                    :purchaseType="cate.purchaseType"
                    :categoryName="item.categoryName"
                  />
                </div>
              </div>
            </div>
          </li>
        </div>
      </ul>
    </div>
    <div
      v-if="isShowSticky"
      class="fixed-menu"
      @mouseenter="showBigNav = true"
      @mouseleave="showBigNav = false"
    >
      <div
        ref="$nav"
        v-if="(availWidth >= 1480 || showBigNav)"
        class="rich-screen"
        :style="{
          left: fixedLeft + 'px',
          width: '140px',
        }"
      >
        <div
          v-for="(item, index) in indexCategoryDtos"
          :key="index"
          :class="{ fixedItem: true, active: index === activeFloor }"
          @click="scrollView(index,item)"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- <div v-else class="poor-screen">
        <div
          v-for="(item, index) in indexCategoryDtos"
          :key="index"
          :class="{ fixedItem: true, active: index === activeFloor }"
          @click="scrollView(index,item)"
        >
          <span class="fixedItem-img">
            <img
              :src="item.imgUrl || require('../../assets/images/smallBell.png')"
              alt
            />
          </span>
          <span class="line-clamp-2">
            {{ item.name }}
          </span>
        </div>
      </div> -->
      <div
        v-else
        key="small"
        class="nav-left-small"
        @mouseenter="showBigNav = true"
        v-html="TLang('Floor', 'my')"
      >
      </div>
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="onCloseSkuModal"
      :onAdd="onClickSkuAdd"
    />
    <FixedButton :channelName="TLang('优选生活', 'my')" />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img :src="require('../../assets/images/cart_ok.png')" />
      <div class="title">{{ TLang('加入购物车成功','my') }}</div>
      <div class="goods-name" v-if="chooseOfAdd.goodsName">
        {{ chooseOfAdd.goodsName }}
      </div>
      <div
        class="goods-sku-name"
        v-if="chooseOfAdd.specValue1 || chooseOfAdd.specName"
      >
        {{TLang('规格','my')}}：{{ chooseOfAdd.specValue1 || chooseOfAdd.specName }}
      </div>
      <div class="btns">
        <button :class="CookiesOne==='en-US' ? 'close-btn close-btn-One' : 'close-btn'" @click="toDetail(chooseOfAdd)">
          {{TLang('查看商品详情','my')}}
        </button>
        <button class="buy-btn primary" @click="onClickGoBuy">{{TLang('去结算','my')}}</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import LeftNavList from "./LeftNavList";
import GoodsItem from "./GoodsItem";
import { CarouselItem, Carousel } from "element-ui";
import SkuPicker from "@components/SkuPicker";
import FixedButton from "@components/FixedButton";
import { Dialog } from "element-ui";
import { fetchLifeIndex, fetchGoodsTags } from "@fetch";
import { fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
import Toast from "@components/simpleToast";
import Cookies from "js-cookie";
import { unionFlag, gioClickHandle, toQsPlus } from "@utils";
import { dealTagGoods } from '@/utils/special'
import { mapActions, mapGetters } from "vuex";
export default {
  name: "LifeIndex",
  components: {
    LeftNavList,
    Carousel,
    CarouselItem,
    GoodsItem,
    // DefBody,
    SkuPicker,
    Dialog,
    FixedButton,
  },
  data() {
    return {
      loading: true,
      catList: [],
      bannerImg: [],
      indexCategoryGoodsDtos: [],
      indexCategoryDtos: [],
      activeFloor: 0,
      isShowSticky: false,
      availWidth: 100,
      scrollList: [],
      SkuPickerShow: false,
      // SkuPickerShow: true,
      activeGoods: {},
      chooseOfAdd: {},
      dialogVisible: false,
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
      fixedLeft: 0,
      unionFlag: unionFlag(),
      CookiesOne:Cookies.get('df_lang'),
      showNavWidth: 0,
      showBigNav: false,
    };
  },
  computed: {
    ...mapGetters("shopCart", ["getCount"]),
    getGoodTagsParams() {
      const goodsList = [];
      this.indexCategoryGoodsDtos.forEach((item) => {
        item.indexSpuGoodsDtoList.forEach((good) => {
          if (item.categoryId)
            goodsList.push({
              categoryId: good.categoryId,
              goodsId: good.goodsId,
            });
        });
      });
      return goodsList;
    },
  },
  created() {
    fetchLifeIndex({ channelId: "2" }).then((res) => {
      if (res) {
        this.loading = false;
        // this.catList = res.indexCategoryDtos;
        this.catList = res.shopCategories;
        let arr = [];
        if (!this.unionFlag && res.pageTemplateInfo && res.pageTemplateInfo.componentLayoutList) {
          arr = this.getBannerInfo(res.pageTemplateInfo.componentLayoutList)
        }
        this.bannerImg = arr && arr.length > 0 ? arr : res.advertisingWheelDtos;
        this.indexCategoryGoodsDtos = res.indexCategoryGoodsDtos;
        this.indexCategoryDtos = res.indexCategoryDtos;
        this.getGoodsTags();
        // 等待dom渲染完 拿到各楼层位置
        setTimeout(() => {
          this.handleScroll();
        }, 1000);
        try {
          this.showNavWidth = this.$refs.$nav.offsetWidth + 24;
        } catch (error) {
          // this.showNavWidth = 0;
        }
      }
    });
    this.cartCount({ ...this.addressInfo });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.listenResize);
    this.availWidth =
      document.body.offsetWidth || document.documentElement.offsetWidth;
    this.computeLeft(this.availWidth >= 1480 ? 160 : 120);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.listenResize);
    this.$bus.$emit("onSticky", false);
  },

  methods: {
    ...mapActions("shopCart", ["cartCount"]),
    getBannerInfo(list) {
      const curAddress = Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}");
      let arrList = [];
      if (list && list.length > 0){
        list.forEach(ele => {
          if (ele.componentCode == 'slider') {
            const content = JSON.parse(ele.content).item.config.list || [];
            if (content && content.length > 0) {
              content.forEach(j => {
                let newUrl = j.linkUrl ? toQsPlus(j.linkUrl, {city: curAddress.cityId || this.addressInfo.cityId || 145}) : null;
                arrList.push({
                  adImg: j.imgUrl,
                  adUrl: newUrl,
                });
              });
            }
          }
        });
      }
      return arrList;
    },
    handleScroll() {
      // f滚动时，左侧菜单高亮
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let len = this.$refs.goodsWrap.children.length;
      this.scrollList = [];
      for (let i = 0; i < len; i++) {
        this.scrollList.push(this.$refs.goodsWrap.children[i].offsetTop - 120);
      }
      for (let j = 0; j < this.scrollList.length; j++) {
        if (
          scrollTop > this.scrollList[j] &&
          scrollTop <= this.scrollList[j + 1]
        ) {
          this.activeFloor = j;
          continue;
        }
        if (scrollTop >= this.scrollList[this.scrollList.length - 1]) {
          this.activeFloor = this.scrollList.length - 1;
        }
      }
      this.isShowSticky = scrollTop >= 80;
      this.$bus.$emit("onSticky", this.isShowSticky);
    },
    listenResize() {
      this.availWidth =
        document.body.offsetWidth || document.documentElement.offsetWidth;
      this.computeLeft(this.availWidth >= 1480 ? 160 : 120);
    },
    computeLeft(width) {
      let showLeft = (this.availWidth - 1200) / 2 - width;
      this.fixedLeft = showLeft > 0 ? showLeft : 0 ;
    },
    scrollView(i,item) {
      const params = {
        df_channle:'优选生活',
        df_pagename:'频道首页',
        df_modulename:'楼层',
        df_elementname:'分类导航',
        df_firstCategory:item.name,
        df_firstCategoryId:''+item.id,
      };
      gioClickHandle('DF_elementClick',params,'channelGio');
      this.$refs.goodsWrap.children[i].scrollIntoView({
        behavior: "smooth",
      });
    },
    toListPage(cat,category = {},type) {
      const params = {
        df_channle:'优选生活',
        df_pagename:'频道首页',
        df_modulename:'分类导航',
      }
      if(type === 1){
        params.df_elementname = '一级分类'
        params.df_firstCategory = category.name,
        params.df_firstCategoryId = ''+category.id
      }else if(type === 2){
        params.df_elementname = '二级分类'
        params.df_secondCategory = category.name,
        params.df_secondCategoryId = ''+category.id
      }else{
        params.df_modulename = '更多分类'
        params.df_elementname = category.name
      }
      gioClickHandle('DF_elementClick',params,'channelGio')
      window.open(`product/list?categoryId=${cat}`, 
        this.isFeishuOrDingding ? '_self' : '_blank'
      )
      // this.$router.push(`product/list?categoryId=${cat}`);
    },
    toDetailPage(goods,categoryName) {
      let spuId = goods.mallSpuId || goods.spuId;
      const params = {
        df_channle:'优选生活',
        df_pagename:'频道首页',
        df_modulename:'楼层',
        df_elementname:'商品详情',
        df_firstCategory:categoryName,
        df_goodsname:goods.goodsName,
        df_spu_code:''+ spuId,
      }
      gioClickHandle('DF_elementClick',params,'channelGio')
      if (goods.goodsType === 0) {
        window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`, 
        this.isFeishuOrDingding ? '_self' : '_blank')  
        // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
      } else if (goods.goodsType === 1) {
        window.open(`/birthday/goods/detail/${goods.spuId}?city=${
          this.addressInfo.cityId || 145
        }`, this.isFeishuOrDingding ? '_self' : '_blank')
        // window.location.href = `/birthday/goods/detail/${goods.spuId}?city=${
        //   this.addressInfo.cityId || 145
        // }`;
      }
    },
    onCloseSkuModal() {
      this.SkuPickerShow = false;
    },
    onClickAdd(goods,category = {}) {
      const params = {
        df_channle:'优选生活',
        df_pagename:'频道首页',
        df_modulename:'楼层',
        df_elementname:'加购',
        df_firstCategory:category.categoryName,
        df_goodsname:goods.goodsName,
        df_spu_code:''+ goods.spuId,
      }
      gioClickHandle('DF_elementClick',params,'channelGio')
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: goods.spuId,
      }).then((body) => {
        if (body) {
          // 单规格
          // console.log(body);
          if (body.length === 1) {
            const myChoose = {
              categoryId: body[0].categoryId,
              goodsId: body[0].goodsId,
              num: body[0].buyMin || 1,
            };
            this.onClickSkuAdd(myChoose);
            return;
          }
          try {
            let checkList = []
            body && body.length > 0 && body.forEach(item => {
              item.tags = []
              if (item.categoryId && item.goodsId) {
                checkList.push({
                  categoryId: item.categoryId,
                  goodsId: item.goodsId,
                })
              }
            })
            checkList && checkList.length > 0 && getActivityTag({
              channel: 2,
              goodsList: checkList,
            }).then((res) => {
              if (res && res.length > 0){
                body && body.length > 0 && body.forEach(item => {
                  item = dealTagGoods(item, res);
                })
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              } else {
                this.activeGoods = goods;
                this.activeGoods.goodsSpecList = body;
                this.SkuPickerShow = true;
              }
            })
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
          }
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
    },
    onClickSkuAdd(myChoose) {
      this.chooseOfAdd = myChoose;
      fetchaddCart({
        categoryId: myChoose.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body) {
          this.dialogVisible = true;
          this.cartCount({ ...this.addressInfo });
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
      this.onCloseSkuModal();
    },
    // 已经修改新窗口
    toDetail(goods) {
      window.open(`/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,this.isFeishuOrDingding ? '_self' : '_blank')
      // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    // 已经修改新窗口
    onClickGoBuy() {
      window.open("/shop/shopping/cart",this.isFeishuOrDingding ? '_self' : '_blank')
      // window.location.href = "/shop/shopping/cart";
    },
    // 商品数据拼接tag
    goodsListAddFlag(res) {
      this.indexCategoryGoodsDtos.forEach((item) => {
        item.indexSpuGoodsDtoList.forEach((good) => {
          const goodTag = res.find(
            (tag) =>
              tag.categoryId == good.categoryId && tag.goodsId == good.goodsId
          ) || {};
          let tags = goodTag && goodTag.tags ? goodTag.tags : [];
          //type  1特价抢购   满减     2爆炸贴       3新品  
          let newTags = tags.filter(item => item.type != 2 )
          let stickerImgList =  tags.filter(item => item.type === 2)
          const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null;
          const salePrice = goodTag && goodTag.tags ? goodTag.salePrice : null;
          const bizStock = goodTag && goodTag.bizStock >= 0 ? goodTag.bizStock : null;
          this.$set(good, "tags", newTags);
          this.$set(good, "promPrice", promPrice);
          this.$set(good, "salePrice", salePrice);
          this.$set(good, "bizStock", bizStock);
          // 拼接折扣信息
          this.$set(good, "discount", goodTag.discount);
          this.$set(good, "discountPrice", goodTag.discountPrice);
          this.$set(good, "discountTagShow", goodTag.discountTagShow);
          this.$set(good, "mktTagShow", goodTag.mktTagShow);
          //爆炸贴数据
          this.$set(good,"stickerImgList",stickerImgList);

          // 福拼拼相关字段
          // Y 为福拼拼
          this.$set(good,"groupItem", goodTag.groupItem);
          // groupItemClassStyle 样式 1、文本模式，2、+货币模式
          this.$set(good,"groupItemClassStyle", goodTag.groupItemClassStyle);
          // 拼团价格
          this.$set(good,"groupItemPrice", goodTag.groupItemPrice);
          // 拼团价格限制 最高可抵扣福豆
          this.$set(good,"groupItemPriceLimit", goodTag.groupItemPriceLimit);
          // 拼团商品是否显示人命币 Y:是 N:否
          this.$set(good,"groupItemShowRmbSymbol", goodTag.groupItemShowRmbSymbol );
        });
      });
    },
    // 获取商品tag
    getGoodsTags() {
      if (this.getGoodTagsParams && this.getGoodTagsParams.length > 0) {
        fetchGoodsTags({ goodsList: this.getGoodTagsParams, channel: 2 }).then(
          (res) => {
            if (res && res.length > 0) {
              this.goodsListAddFlag(res);
            }
          }
        );
      }
    },
    // 点击轮播图
    clickCarousel(item){
      const params = {
        df_channle:'优选生活',
        df_pagename:'频道首页',
        df_modulename:'轮播',
        df_elementname:''+item.id,
      }
      gioClickHandle('DF_elementClick',params,'channelGio')
      window.location.href = this.unionFlag ? item.bfdUrl ? item.bfdUrl : 'javascript:void(0)' : item.adUrl ? item.adUrl : 'javascript:void(0)'
    }
  },
};
</script>

<style lang="less">
.LifeIndex {
  .advise-banner {
    display: flex;
    padding-top: 44px;
    overflow-y: hidden;
    margin-left: -20px;
    /deep/ .cat-list {
      width: 220px;
      margin-top: -44px;
    }
    .el-carousel {
      flex: 1;
      .el-carousel__container {
        a {
          display: inline-block;
          width: 100%;
          img {
            width: 1200px;
            height: 450px;
          }
        }
        .el-carousel__arrow {
          width: 50px !important;
          height: 100px !important;
          border-radius: 0;
          i {
            font-size: 35px;
            color: #ededed;
            opacity: 0.9;
          }
        }
        .el-carousel__arrow--left {
          left: 0;
        }
        .el-carousel__arrow--right {
          right: 0;
        }
      }
      .el-carousel__indicators {
        .el-carousel__button {
          width: 10px;
          height: 10px;
          background: rgba(255, 255, 255, 1);
          border-radius: 50%;
        }
      }
    }
    .bfd-banner {
      height: 455px;
      width: 980x;
      overflow: hidden;
      img {
        display: block;
        margin: 0;
        width: 100%;
      }
    }
  }
  .goods-wrap {
    padding-top: 30px;
    ul {
      li {
        margin-bottom: 60px;
        .header-title {
          display: flex;
          justify-content: space-between;
          padding-bottom: 10px;
          border-bottom: 1px solid #f0f0f0;
          align-items: baseline;
          padding-top: 140px;
          margin-top: -140px;
          .title-left {
            font-size: 24px;
            color: rgba(51, 51, 51, 1);
            // margin-left: 20px;
            .en {
              font-size: 14px;
              color: rgba(204, 204, 204, 1);
            }
          }
          .title-right {
            display: flex;
            align-items: center;
            .icon {
              transform: rotate(90deg);
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
        .goodsList {
          display: flex;
          flex-wrap: wrap;
          .item {
            margin-right: 12px;
            padding: 15px 0;
            margin-top: 10px;
            &:hover {
              box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.05);
            }
          }
          .item:nth-child(5n) {
            margin-right: 0;
          }
        }
      }
    }
  }
  .fixed-menu {
    position: fixed;
    // box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    // background: #fff;
    background: transparent;
    top: 100px;
    left: 0;
    width: auto;
    min-width: 40px;
    text-align: center;
    z-index: 1000;
    .rich-screen {
      width: 140px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      background: #fff;
      max-height: 70vh;
      overflow-y: scroll;
      position: relative;
      top: 0;
      transition: all 0.3s ease-in;
    }
    .poor-screen {
      width: 40px;
      position: relative;
      top: 0;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      background: #fff;
      .fixedItem {
        width: 40px;
        height: 40px;
        line-height: 14px;
        word-break: break-all;
        position: relative;
        img {
          width: 60%;
          height: 60%;
          vertical-align: top;
        }
        .line-clamp-2 {
          display: none;
          position: absolute;
          top: 4px;
          right: 4px;
          bottom: 4px;
          left: 4px;
          color: #3d96e2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 16px;
        }
        &:hover img {
          display: none;
        }
        &:hover .line-clamp-2 {
          display: -webkit-box;
        }
        &:hover {
          background: #fff;
        }
        &.active:hover {
          // background: linear-gradient(
          //   315deg,
          //   rgba(92, 180, 236, 1) 0%,
          //   rgba(61, 150, 226, 1) 100%
          // );
          background: #247dff;
          color: #fff;
        }
      }
    }
    .nav-left-small {
      position: relative;
      top: 0;
      left: 0;
      z-index: 999;
      font-size: 20px;
      padding: 16px 6px;
      font-weight: bold;
      // background: linear-gradient(
      //   315deg,
      //   rgba(92, 180, 236, 1) 0%,
      //   rgba(61, 150, 226, 1) 100%
      // );
      background: #247dff;
      color: #fff;
      line-height: 26px;
      // text-shadow:0px 6px 16px rgba(0,0,0,0.15), 0px 2px 4px rgba(194,71,70,0.75);
      border-radius: 0px 8px 8px 0px;
      writing-mode: vertical-lr;
      transition: all 0.3s ease-in;
    }
    .fixedItem {
      font-size: 12px;
      color: #222;
      line-height: 32px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 18px;
      &-img {
        display: table-cell;
        vertical-align: middle;
        width: 40px;
        height: 40px;
      }
    }
    .fixedItem.active {
      color: #fff;
      // background: linear-gradient(
      //   315deg,
      //   rgba(92, 180, 236, 1) 0%,
      //   rgba(61, 150, 226, 1) 100%
      // );
      background: #247dff;
      img {
        display: none;
      }
      .line-clamp-2 {
        display: -webkit-box;
        color: #fff;
      }
    }
    .fixedItem:hover {
      color: #fff;
      // background: linear-gradient(
      //   315deg,
      //   rgba(92, 180, 236, 1) 0%,
      //   rgba(61, 150, 226, 1) 100%
      // );
      background: #247dff;
      cursor: pointer;
    }
  }
  .header-body-sticky {
    position: fixed;
    top: 0;
    background: #fff;
    z-index: 999;
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.05);
  }
  /deep/ .product-dialog {
    .title {
      margin-top: 18px;
    }
    .goods-name {
      color: #7f7f7f;
      margin-top: 18px;
    }
    .goods-sku-name {
      color: #b2b2b2;
      margin-top: 5px;
    }
  }
}
.close-btn-One{
  width: auto!important;
  padding: 0 20px;
}
</style>
